import "@/App.css";
import { ReactLenis } from "lenis/react";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import Menu from "@/sections/Menu";
import Gallery from "@/sections/Gallery";
import Visit from "@/sections/Visit";
import Marquee from "@/sections/Marquee";
import Footer from "@/sections/Footer";
import AdminControls from "@/components/AdminControls";

const Site = () => {
  const { content } = useSite();
  if (!content) {
    return <div className="min-h-screen bg-[#F5F2EA]" data-testid="site-loading" />;
  }
  return (
    <div className="App bg-[#F5F2EA] text-[#1A1713]" data-testid="kals-cafe-site">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <About />
        <Menu />
        <Gallery />
        <Visit />
        <Marquee />
      </main>
      <Footer />
      <AdminControls />
      <Toaster position="bottom-center" />
    </div>
  );
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 0.9 }}>
      <SiteProvider>
        <Site />
      </SiteProvider>
    </ReactLenis>
  );
}

export default App;
